import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

export const getPhotoSearchCheckoutSearchItemsQuery = gql`
  query getPhotoSearchCheckoutSearchItems {
    searchSubscriptionItems(platform: WEB) {
      id
      plan
      days
      billing_period
      trial_days
      price {
        value
        currency
      }
    }
  }
`;

const getPhotoSearchCheckoutSearchItems = graphql(
  getPhotoSearchCheckoutSearchItemsQuery,
);

export default getPhotoSearchCheckoutSearchItems;
